'use client';
import { FC, useState } from 'react';

import { SubmitButton } from 'src/general/components/Button/SubmitButton';
import { Image } from 'src/general/components/Image/Image';
import { FormWithAction } from 'src/general/components/forms/FormWithAction/FormWithAction';
import { InputEmailForm } from 'src/general/components/forms/Input/InputEmailForm';
import { InputForm } from 'src/general/components/forms/Input/InputForm';

import { submitInvestorNewsletterAction } from './actions/submitInvestorNewsletter.action';

const InvestorNewsletterFormCopy = {
  heading: 'Investor newsletter',
  subHeading: 'Get our company updates delivered straight to your inbox.',
};

export const InvestorNewsletterForm: FC = () => {
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  return (
    <section className="border-b border-bor-neu-mut">
      <div className="mx-auto max-w-7xl py-10 lg:pb-14">
        <div className="mb-6">
          <h5 className="c-fs-h5 font-extrabold">{InvestorNewsletterFormCopy.heading}</h5>
          <p className="c-fs-body2 text-tex-def-tie2">{InvestorNewsletterFormCopy.subHeading}</p>
        </div>

        <FormWithAction
          action={submitInvestorNewsletterAction}
          withRecaptcha="newsletter_form_submit"
          onSuccess={() => {
            setIsSuccess(true);
          }}
          renderContent={(state) => (
            <div className="w-full gap-4 md:flex">
              <div className="w-full grid-cols-2 gap-4 md:grid">
                <div className="grid grid-cols-2 gap-4">
                  <InputForm name="first_name" label="First name" formState={state} />
                  <InputForm name="last_name" label="Last name" formState={state} />
                </div>
                <InputEmailForm name="email" label="Email address" formState={state} className="w-full" />
              </div>
              <footer className="">
                <SubmitButton className="w-full md:w-24">Sign up</SubmitButton>
              </footer>
            </div>
          )}
        />

        {isSuccess ? (
          <div className="mt-4 flex flex-row items-center gap-2 smp:justify-center">
            <div className="text-for-suc-bas">
              <Image src="/images/circle-check.svg" width={16} height={16} alt="Check" />
            </div>
            <p className="c-fs-body1 text-tex-def-tie1">Successfully subscribed to the investor newsletter</p>
          </div>
        ) : null}
      </div>
    </section>
  );
};
